module.exports = __webpack_public_path__ + "static/media/roxy.d3656eb8.svg";